// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3a91X","icon":"Loader_icon__26xUl"};